export default __webpack_public_path__ + "static/PTSI-75a562a474778031c98d28700fb37f5c.svg";